/* Action types */
export const TOGGLE_NAVIGATION = 'TOGGLE_NAVIGATION';
export const SET_NAVIGATION = 'SET_NAVIGATION';
export const SET_HOME_LINK = 'SET_HOME_LINK';

/* Action creators */

export function toggleNavigation(toggle) {
  return {
    type: TOGGLE_NAVIGATION,
    toggle,
  }
}

export function setNavigation(items) {
  return {
    type: SET_NAVIGATION,
    items,
  }
}

export function setHomeLink(url) {
  return {
    type: SET_HOME_LINK,
    url,
  }
}



// WEBPACK FOOTER //
// ./src/actions/navigation.jsx